import { Routes, Route } from 'react-router-dom';
import MainPage from '../js/MainPage';
import WhyTestops from '../js/WhyTestops/WhyTestops';
import Flow from '../js/Solutions/Flow';
import WorkFlow from '../js/Solutions/WorkFlow';
import SelfLogin from '../js/SelfService/SelfLogin';
import SelfserviceTable from '../js/SelfService/SelfserviceTable';
import FrothAI from '../js/FrothAI/FrothAI';
import TermsCondition from '../js/TermsConditions/TermsCondition';
import PrivacyPolicy from '../js/PrivacyPolicy/PrivacyPolicy';
import ChangeLog from '../js/ChangeLog/ChangeLog';
import Integration from '../js/Integration/Integration';
import MobileApp from '../js/MobileApp/MobileApp';
import ContactUS from '../js/ContactUS/ContactUS';
import NotFound from '../js/NotFound';

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<MainPage />} />
      <Route path="/why-testops" element={<WhyTestops />} />
      <Route path="/byteam" element={<Flow />} />
      <Route path="/workflow" element={<WorkFlow />} />
      <Route path="/login" element={<SelfLogin />} />
      <Route path="/self-servicedashboard" element={<SelfserviceTable />} />
      <Route path="/froth-ai" element={<FrothAI />} />
      <Route path="/term-condition" element={<TermsCondition />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/change-log" element={<ChangeLog />} />
      <Route path="/integration" element={<Integration />} />
      <Route path="/mobile-app" element={<MobileApp />} />
      <Route path="/contact" element={<ContactUS />} />

      {/* Catch-all route - show 404 page for invalid paths */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default AppRoutes;